import { assign, has, get } from 'lodash';
import { IIncident } from '@/types';

export const incidentFactory = (incident: IIncident | undefined = undefined): IIncident => {
    const newIncident = assign({}, {
        description: '',
        // eslint-disable-next-line @typescript-eslint/camelcase
        level_id: '',
        title: '',
        // eslint-disable-next-line @typescript-eslint/camelcase
        created_for: new Date(),
    }, incident);
    if (incident && has(incident, 'theme.id')) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        newIncident.theme_id = get(incident, 'theme.id');
    }

    if (incident && has(incident, 'level.id')) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        newIncident.level_id = get(incident, 'level.id');
    }

    return newIncident;
};

export default incidentFactory;
